"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _appCitysData = _interopRequireDefault(require("../../assets/static/js/citys/app.citys.data.js"));
var _api = require("../../api/api.js");
var _cryptoJs = _interopRequireDefault(require("crypto-js"));
var _default = exports.default = {
  props: {
    sourceType: {
      type: String,
      default: '10'
    }
  },
  data: function data() {
    return {
      showDialog: false,
      citys: _appCitysData.default.cityDataWithoutDistrict,
      //出发城市数据
      formData: {
        trueName: '',
        phone: '',
        company: '',
        areaId: '',
        verificationCode: ''
      },
      Rules: {
        phone: [{
          required: true,
          message: '请输入手机号码',
          trigger: 'blur'
        }, {
          pattern: /^1\d{10}$/,
          message: '请输入正确的手机号码',
          trigger: 'blur'
        }],
        trueName: [{
          required: true,
          message: '请填写您的姓名',
          trigger: 'blur'
        }],
        company: [{
          required: true,
          message: '请填写您的姓名',
          trigger: 'blur'
        }],
        areaId: [{
          required: true,
          message: '请选择出发城市',
          trigger: 'change'
        }],
        verificationCode: [{
          required: true,
          message: '请填写验证码',
          trigger: 'blur'
        }]
      },
      codeBtnShow: true,
      //控制验证码按钮
      count: '',
      //验证码按钮倒计时
      timer: null //定时器timer
    };
  },
  methods: {
    //选择出发城市
    startCityChange: function startCityChange(value) {
      console.log('选择出发城市', value);
      this.formData.areaId = value[value.length - 1];
    },
    // 发送验证码
    toGetCode: function toGetCode() {
      // let timestamp = parseInt(new Date().getTime() / 1000) + ""
      // let str = timestamp + this.formData.phone + "2"
      // let param = {
      // 	phone: this.formData.phone,
      // 	type: '2', //验证码类型  0、注册   1、忘记密码 2、单纯发验证码（登录注册一体接口要传2了）
      // 	timestamp: timestamp,
      // 	sign: CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256(str, 'xiamenjinye'))
      // };

      // let param2 = {
      // 	fun: 'sendVerificationCode',
      // 	param: param,
      // 	version: 1
      // }
      // let codeParam = {
      // 	jsonParamete: JSON.stringify(param2)
      // }
      var param = {
        phone: this.formData.phone,
        type: 0,
        sourceType: 10
      };
      this.getCode(param);
    },
    getCode: function () {
      var _getCode = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(param) {
        var _this = this;
        var TIME_COUNT, _yield$apiGetCode, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              TIME_COUNT = 60;
              _context.next = 3;
              return (0, _api.apiGetCode)(param);
            case 3:
              _yield$apiGetCode = _context.sent;
              data = _yield$apiGetCode.data;
              if (data.proCode == '200') {
                this.$message({
                  message: '发送成功!',
                  type: 'success'
                });
                // 验证码倒计时
                if (!this.timer) {
                  this.count = TIME_COUNT;
                  this.codeBtnShow = false;
                  this.timer = setInterval(function () {
                    if (_this.count > 0 && _this.count <= TIME_COUNT) {
                      _this.count--;
                    } else {
                      _this.codeBtnShow = true;
                      clearInterval(_this.timer);
                      _this.timer = null;
                    }
                  }, 1000);
                }
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getCode(_x) {
        return _getCode.apply(this, arguments);
      }
      return getCode;
    }(),
    submit: function submit(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid, obj) {
        if (valid) {
          _this2.saveData();
        } else {
          // 验证失败
          console.log('error submit!!', obj);
          // 取错误信息对象里的第一个数组,抛出错误提示
          var key = Object.keys(obj)[0];
          _this2.$message({
            message: obj[key][0].message,
            type: 'error',
            duration: '3000'
          });
          return false;
        }
      });
    },
    saveData: function () {
      var _saveData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$apiSaveApply, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _api.apiSaveApply)(Object.assign(this.formData, {
                sourceType: this.sourceType
              }));
            case 2:
              _yield$apiSaveApply = _context2.sent;
              data = _yield$apiSaveApply.data;
              if (data.proCode == 200) {
                this.showDialog = true;
                this.$data.formData = this.$options.data.call(this).formData;
                this.$refs.city.$refs.panel.clearCheckedNodes();
              }
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function saveData() {
        return _saveData.apply(this, arguments);
      }
      return saveData;
    }()
  }
};